var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation footer"},[_c('GrootTwsFooter',{attrs:{"address":_vm.address,"customLinks":_vm.customLinks,"navigationLinks":_vm.filteredNavigationLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }